import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, Select, Skeleton } from 'antd';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import moment from 'moment';
import { getUserHashrateChartData, isLoadingStatsUser } from '../../../redux/selectors/stats';
import _ from 'lodash';
import TranslatedText from '../../TranslatedText';
import { withTranslation } from 'react-i18next';
import { calculateTicks } from './charts';
import {hashrateToString, hashrateValue, hashrateUnit} from '../../../services/hashrate';

const defaultState = {
  chartTimespanHours: 24,
  tickXFormat: 'LT',
};

class UserHashrateChart extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = defaultState;
    this.updateTimespan = this.updateTimespan.bind(this);
  }

  updateTimespan(value) {
    this.setState({chartTimespanHours: value, tickXFormat: value > 24 ? 'L' : 'LT'});
  }

  render() {
    const data = _.takeRight(this.props.chartData, this.state.chartTimespanHours);
    const current = _.last(data);
    const ticks = current ? calculateTicks(current.timestamp, this.state.chartTimespanHours, 6) : [];

    return (
      <Card
        id="user-hashrate-chart"
        title={<TranslatedText transKey="dashboard.userchart.title" />}
        extra={
          <React.Fragment>
            <span>
              <TranslatedText transKey="dashboard.filters.show" />
            </span>
            <Select defaultValue="24" onChange={this.updateTimespan}>
              <Select.Option value="12">
                <TranslatedText transKey="dashboard.filters.12hrs" />
              </Select.Option>
              <Select.Option value="24">
                <TranslatedText transKey="dashboard.filters.24hrs" />
              </Select.Option>
              <Select.Option value="168">
                <TranslatedText transKey="dashboard.filters.lastweek" />
              </Select.Option>
            </Select>
          </React.Fragment>
        }
        bordered={false}
      >
        <ResponsiveContainer width="100%" height={200}>
          {this.props.userStatsLoading ? (
            <Skeleton active title={false} paragraph={{ rows: 1, width: '90%' }} />
          ) : (
            <AreaChart data={data} margin={{top: 10, right: 30, left: 20, bottom: 0}}>
              <defs>
                <linearGradient id="chartColor" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="30%" stopColor="#efc563" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#efc563" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeWidth="0.5" vertical={false} />
              <XAxis
                dataKey="timestamp"
                domain={['dataMin', 'dataMax']}
                name="Time"
                tickFormatter={timestamp => moment.unix(timestamp).format(this.state.tickXFormat)}
                label={
                  _.maxBy(data, 'hashrate').hashrate === 0 && {
                    value: this.props.t('dashboard.userchart.noStatsCollected'),
                    position: 'top',
                    offset: 80,
                  }
                }
                type="number"
                axisLine={false}
                tickLine={false}
                ticks={ticks}
              />
              <YAxis axisLine={false} tickLine={false} tickFormatter={value => hashrateValue(value) + hashrateUnit(value)}/>
              <Tooltip
                formatter={value => [hashrateToString(value), 'User Hashrate:']}
                labelFormatter={label => moment.unix(label).format('L LT')}
              />
              <Area strokeWidth={4} type="monotone" dataKey="hashrate" stroke="#efc563" fill="url(#chartColor)" />
            </AreaChart>
          )}
        </ResponsiveContainer>
      </Card>
    );
  }
}

UserHashrateChart.propTypes = {
  chartData: PropTypes.arrayOf(
    PropTypes.shape({
      timestamp: PropTypes.number,
      hashrate: PropTypes.number,
    })
  ),
  userStatsLoading: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  chartData: getUserHashrateChartData(state),
  userStatsLoading: isLoadingStatsUser(state),
});

export default connect(mapStateToProps)(withTranslation()(React.memo(UserHashrateChart)));



// WEBPACK FOOTER //
// /src/components/pages/dashboard/UserHashrateChart.jsx